import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';
import hasPermission from '../../../../Shared/hasPermission';

const SearchPracticeGroupsToggle = ({ styles = {} }) => {
    // bool tied to the Serch Practice Groups toggle in the text search section
    const searchGroups = useSelector(state => state.practice.searchGroups);

    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(actions.practice.setSearchGroups(!searchGroups))
    }, [searchGroups, dispatch]);

    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const can = (permission) => hasPermission(permission, permissions);
    const canSearchGroups = can('SearchGroups');

    if(!canSearchGroups) return [];
    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={searchGroups}
            label='Search Practice Groups'
        />
    );
};

export default SearchPracticeGroupsToggle;
